const laboratorioInitialState = {
    turnosSeleccionadosLabo: {
        loading: false,
        error: null,
        data: null, 
        actual: 0, 
        mercadoPago: {
            qr: false,
            referenciaExterna:false,
            idWebservice: false
        }, 
        nro_afiliado: false
    },
};

export default laboratorioInitialState;